/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Visibility_PublicInputs */

const en_dialog_visibility_public = /** @type {(inputs: Dialog_Visibility_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public`)
};

const es_dialog_visibility_public = /** @type {(inputs: Dialog_Visibility_PublicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Público`)
};

/**
* | output |
* | --- |
* | "Public" |
*
* @param {Dialog_Visibility_PublicInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_visibility_public = /** @type {((inputs?: Dialog_Visibility_PublicInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Visibility_PublicInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_visibility_public(inputs)
	return en_dialog_visibility_public(inputs)
});